<template>
    <CardUploadFiles
        :titleCard="'Precisamos verificar a parte de trás do seu veículo'"
        :cardDescription="'vehicle_back'"
        :textCard="'Traseira do veículo'"
        :srcExampleImage="ImageFrontVehicle"
        :nextRoute="'VehicleTrunk'"
        :previewScreen="'PreviewVehicleFiles'"
    />
</template>
<script>
    import CardUploadFiles from '../../components/CardUploadFiles.vue'
    import ImageFrontVehicle from '../../../../public/images/back.svg'
   
    export default {
        components: {
            CardUploadFiles
        },
        setup() {
            return {          
                ImageFrontVehicle
            };
        }, 
    }
</script>